<div class="nav-plan-wrapper"
  [ngClass]="{
    'is-opened': hudBottomOpened(),
    'hide-navigation-plan': mobileVisiblePanel() == 'car',
    'no-turn': !hasTurn()
  }">

  <div class="np-card"
    #npCard
    [class.is-dragging]="isDragging()"
    [style.height.px]="appliedHeight()">

    @if (chargeState() == ChargeState.None && !betterRouteVisible()) {
    <div class="pane-drag-outer" #paneDragOuter>
      <div class="pane-drag-element"></div>
    </div>
    }

    <!-- Better route offer: takes the whole card over, like the charging stop -->
    @if (betterRouteVisible()) {
      <app-navigation-plan-better-route
        [message]="betterRouteMessage()"
        [timeoutMs]="betterRouteTimeoutMs"
        (acceptClick)="acceptBetterRoute()"
        (dismissClick)="dismissBetterRoute()">
      </app-navigation-plan-better-route>
    }

    @if (!betterRouteVisible()) {
      <!-- Battery / charger header -->
      <app-navigation-plan-header
        [estimatedBatteryLevel]="estimatedBatteryLevel()"
        [chargeState]="chargeState()"
        [chargerName]="arrivedChargerDetails()?.Name ?? ''">
      </app-navigation-plan-header>

      <!-- Normal navigation rows -->
      @if (chargeState() == ChargeState.None) {
        <app-navigation-plan-normal-state
          [hudBottomOpened]="hudBottomOpened()"
          [isDragging]="isDragging()"
          [computersArray]="computersArray()"
          [cannotSkipMoreChargingStation]="CannotSkipMoreChargingStation()"
          (skipWaypointClick)="skipWaypoint()"
          (skipChargingStationClick)="skipChargingStation()"
          (stopNavigationClick)="stopNavigation()"
          (batteryReservedWarningClick)="openBatteryReservedSnackbar()">
        </app-navigation-plan-normal-state>
      }

      <!-- Charge state UI (preserved from legacy) -->
      @if (chargeState() != ChargeState.None) {
        <app-navigation-plan-charge-state
          [arrivedAtMessage]="arrivedAtMessage()"
          [arrivedChargerDetails]="arrivedChargerDetails()"
          [chargeTime]="chargeTime()"
          [chargeState]="chargeState()"
          [arrivedChargerIsEndpoint]="arrivedChargerIsEndpoint()"
          (startChargeClick)="startCharge()"
          (replanNavigationClick)="replanNavigation()"
          (stopNavigationClick)="stopNavigation()"
          (finishChargeClick)="finishCharge()">
        </app-navigation-plan-charge-state>
      }
    }
  </div>
</div>
